import ArrowsSync16 from '@common/components/icons/ArrowsSync16';
import CurrencyDollar16 from '@common/components/icons/CurrencyDollar16';
import { TextWithLeadingIconCell } from '@common/components/Table/TextWithLeadingIconCell';

/**
 * Get icon component for payment choice
 */
const getPaymentChoiceIcon = (choice: string | undefined) => {
	if (!choice) return null;

	switch (choice) {
		case 'Financing':
			return <ArrowsSync16 />;
		case 'Full cash':
			return <CurrencyDollar16 />;
		default:
			return null;
	}
};

interface PaymentChoiceCellProps {
	paymentChoice: string | undefined;
}

export const PaymentChoiceCell = ({ paymentChoice }: PaymentChoiceCellProps) => {
	const choiceText = paymentChoice;
	const icon = getPaymentChoiceIcon(paymentChoice);

	return <TextWithLeadingIconCell text={choiceText ?? ''} icon={icon} />;
};
